import(/* webpackMode: "eager" */ "/vercel/path0/app/(dashboard)/seasons/page.jsx");
